export default __webpack_public_path__ + "static/media/avatar-logo-upload.75adc483.png";